export default __webpack_public_path__ + "static/PromptIconFive-8a46ad3255fae57884dd250a365be835.png";